/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationPolicyDeleteResponseOutputIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const NotificationPolicyDeleteResponseOutput = zod.object({
  id: zod.uuid().regex(notificationPolicyDeleteResponseOutputIdRegExp),
  deleted: zod.literal(true),
});

export type NotificationPolicyDeleteResponseOutput = zod.input<
  typeof NotificationPolicyDeleteResponseOutput
>;
export type NotificationPolicyDeleteResponseOutputOutput = zod.output<
  typeof NotificationPolicyDeleteResponseOutput
>;
